import { useEffect, useRef } from 'react';

import { THEME_REFRESH_MINUTES_INTERVAL } from '../functions/remoteTheme';

export const useThemeRefreshInterval = (callback: () => void) => {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const now = new Date();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();

    const minutesToNextExecution = THEME_REFRESH_MINUTES_INTERVAL - (minutes % THEME_REFRESH_MINUTES_INTERVAL);
    const millisecondsToNextExecution = (minutesToNextExecution * 60 - seconds) * 1000 - milliseconds;

    let intervalInstance: ReturnType<typeof setInterval> | undefined = undefined;
    const timeoutInstance = setTimeout(() => {
      savedCallback.current();
      const intervalMilliseconds = THEME_REFRESH_MINUTES_INTERVAL * 60 * 1000;
      intervalInstance = setInterval(() => savedCallback.current(), intervalMilliseconds);
    }, millisecondsToNextExecution);

    return () => {
      clearTimeout(timeoutInstance);
      clearInterval(intervalInstance);
    };
  }, []);
};
